var serviceTemplates = {
    list: function(page){
        var params = {
            page: (page || 1),
            like: $('#like').val(),
            screen_type: $('#screen-list-screen_type').val(),
        };

        var getParams = location.pathname +"?"+ ($.param(params));

        if(window.history && window.history.replaceState)
        {
            window.history.replaceState(null, null, getParams);

            $.get(getParams, params, function(resp){
                $("#screen_list").html(resp);
            });
        } else {
            location.href = getParams;
        }
    },
    /**
     * Visszatér egy popup-pal, amivel id-től függően, létrehozható vagy módosítható egy serviceTemplate
     * @param string screenID
     */
    serviceTemplate: function(serviceTemplateID){
        var screenID = screenID || 0;

        $.post('/CMS/serviceTemplates/serviceTemplate/' + serviceTemplateID, {}, function(resp){
            popup(resp.html, resp.title).dialog();
        }, 'json');
    },

    getCurrentFormOfServiceTemplate: function(serviceID, JSONOfCurrentValuesOfServiceConfig)
    {
        var serviceTemplateID = $('#serviceTemplateID').val();

        $.post(
            '/admin/devices/renderServiceTemplateSelectOrServiceJSONCompilerHTML',
            {
                serviceID: serviceID,
                serviceTemplateID: serviceTemplateID,
                JSONOfCurrentValuesOfServiceConfig: JSONOfCurrentValuesOfServiceConfig
            },
            function (resp) {
                $("#serviceConfigFormContainer").html(resp);
                $("#addServiceToDevicePositionBtn").show();
            }
        );
    },



    // migrated:

    showAddNewServiceToDevicePositionPopup: function (devicePositionID) {
        if(!devicePositionID)
        {
            console.log('Invalid devicePositionID');
            return false;
        }

        $.post(
            '/admin/devices/renderServicesListHTML',
            {
                devicePositionID: devicePositionID
            },
            function(r){
                popup(r.html, r.title).setSettings({"size":"large"}).dialog();
            },
            'json'
        );
    },

    saveServiceJSONToDevicePosition: function (devicePositionID) {
        // the clicked button
        var button = $('#addServiceToDevicePositionBtn');

        // getting the clicked command
        var onclickCommand = button.attr('onclick');

        // removing the clicked command for the time of the process to prevent multiple execution
        button.attr('onclick', '');

        // showing spinner icon on button
        $('#addServiceToDevicePositionBtn .fa-spinner').show();

        // if form is valid
        if(serviceTemplates.validateServiceJSONCompilerForm())
        {
            // saving service to position
            $.post(
                '/admin/devices/saveServiceJSONToDevicePosition',
                {
                    serviceID: $("#availableServicesSelect").val(),
                    serviceTemplateID: $("#serviceTemplateID").val(),
                    devicePositionID: devicePositionID,
                    formData: $('#serviceJSONCompilerForm').serializeArray()
                },
                function(r)
                {
                    var locationID = r.locationIDOfDevicePosition;

                    // replacing location html
                    $(".locationrow_"+ locationID +".stage").remove();
                    $(".locationrow_"+ locationID +".after").after(r.locationHTML);

                    closeLastPopup();
                },
                'json'
            );
        }

        // form is invalid
        else
        {
            // restoring button's onclick command
            button.attr('onclick', onclickCommand);

            // hiding spinner icon from button
            $('#addServiceToDevicePositionBtn .fa-spinner').hide();
        }
    },

    updateServiceJSONOfDevicePosition: function (devicePositionID, serviceID) {
        // the clicked button
        var button = $('#updateServiceJSONOfDevicePositionBtn');

        // getting the clicked command
        var onclickCommand = button.attr('onclick');

        // removing the clicked command for the time of the process to prevent multiple execution
        button.attr('onclick', '');

        // showing spinner icon on button
        $('#updateServiceJSONOfDevicePositionBtn .fa-spinner').show();

        // if form is valid
        if(serviceTemplates.validateServiceJSONCompilerForm())
        {
            // updating service on position
            $.post(
                '/admin/devices/updateServiceJSONOfDevicePosition',
                {
                    serviceID: serviceID,
                    serviceTemplateID: $("#serviceTemplateID").val(),
                    serviceTemplateJSON: $("#serviceTemplateJSON").html(),
                    devicePositionID: devicePositionID,
                    formData: $('#serviceJSONCompilerForm').serializeArray()
                },
                function()
                {
                    closeLastPopup();
                },
                'json'
            );
        }
    },

    removeServiceFromDevicePosition: function (devicePositionID, serviceID) {
        // the clicked button
        var button = $('#removeServiceFromDevicePositionBtn');

        // getting the clicked command
        var onclickCommand = button.attr('onclick');

        // removing the clicked command for the time of the process to prevent multiple execution
        button.attr('onclick', '');

        // showing spinner icon on button
        $('#removeServiceFromDevicePositionBtn .fa-spinner').show();

        // removing service from position
        $.post(
            '/admin/devices/removeServiceFromDevicePosition',
            {
                serviceID: serviceID,
                devicePositionID: devicePositionID
            },
            function(r)
            {
                var locationID = r.locationIDOfDevicePosition;

                // replacing location html
                $(".locationrow_"+ locationID +".stage").remove();
                $(".locationrow_"+ locationID +".after").after(r.locationHTML);

                closeLastPopup();
            }
        );
    },

    isJsonString: function(str)
    {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },

    validateServiceJSONCompilerForm: function (formInputs) {
        var valid = true;


        var formElements = formInputs || $('#serviceJSONCompilerForm :input');

        $('.serviceJSONCompilerFormErrorMsg').remove();

        formElements.each(function () {
            $(this).removeClass('has-error');
        });

        formElements.each(function () {
            var customParams = $(this).data();
            var filledValue = $(this).val();

            customParamsValidationLoop:
                for(var customParam in customParams)
                {
                    switch (customParam) {
                        case 'required':
                            if ($(this).val().trim() == '') {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'This field is required');
                                valid = false;
                                break customParamsValidationLoop;
                            }
                            break;

                        case 'datatype':

                            switch (customParams[customParam]) {
                                case 'Integer':
                                    var digitsOnlyPattern = /^\d+$/;
                                    if (!digitsOnlyPattern.test(filledValue)) {
                                        serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be integer');
                                        valid = false;
                                        break customParamsValidationLoop;
                                    }
                                    break;

                                case 'Float':
                                    var precisions = $(this).data('precision').split(':');
                                    var decimalsMin = precisions[0] || 0;
                                    var decimalsMax = precisions[1] || '';
                                    var floatOnlyPattern = new RegExp("^[\-]?([0-9]+[.])+[0-9]{" + decimalsMin + "," + decimalsMax + "}$");
                                    if (!floatOnlyPattern.test(filledValue)) {
                                        var from = decimalsMin == 0 ? '' : ' from ' + decimalsMin;
                                        var to = decimalsMax == '' ? '' : ' to ' + decimalsMax;
                                        serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be float with a precision ' + from + to);
                                        valid = false;
                                        break customParamsValidationLoop;
                                    }
                                    break;

                                case 'Boolean':
                                    if (['true', 'false'].indexOf(filledValue) < 0) {
                                        serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be true or false');
                                        valid = false;
                                        break customParamsValidationLoop;
                                    }
                                    break;

                                case 'JSON':
                                    if (!serviceTemplates.isJsonString(filledValue)) {
                                        serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be valid JSON');
                                        valid = false;
                                        break customParamsValidationLoop;
                                    }
                                    break;
                            }

                            break;

                        case 'range':
                            // first checking if value is integer or float only
                            var integerOrFloatOnlyPattern = new RegExp("^[-]?[0-9]+([.][0-9]+)*$");
                            if (!integerOrFloatOnlyPattern.test(filledValue)) {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value type must be ' + $(this).data('datatype'));
                                valid = false;
                                break customParamsValidationLoop;
                            }

                            var extremes = customParams[customParam].split(':');

                            // testing filledValue against rules
                            if (extremes[0] && Number(filledValue) < Number(extremes[0])) {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be at least ' + extremes[0]);
                                valid = false;
                                break customParamsValidationLoop;
                            }

                            if (extremes[1] && Number(filledValue) > Number(extremes[1])) {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be maximum of ' + extremes[1]);
                                valid = false;
                                break customParamsValidationLoop;
                            }

                            break;

                        case 'length':
                            var limits = customParams[customParam].split(':');

                            if (limits[0] && filledValue.length < limits[0]) {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be at least ' + limits[0] + ' characters long');
                                valid = false;
                                break customParamsValidationLoop;
                            }

                            if (limits[1] && filledValue.length > limits[1]) {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be maximum of ' + limits[1] + ' characters long');
                                valid = false;
                                break customParamsValidationLoop;
                            }

                            break;

                        case 'options':
                            var options = customParams[customParam].split(';');

                            if (options.indexOf(filledValue) < 0) {
                                serviceTemplates.showErrorMsgOfServiceJSONCompilerFormElement($(this), 'Value must be ' + options.join(" or "));
                                valid = false;
                                break customParamsValidationLoop;
                            }

                            break;
                    }
                }
        });

        return valid;
    },

    showErrorMsgOfServiceJSONCompilerFormElement: function (element, msg) {
        element.addClass('has-error').after('<span class="serviceJSONCompilerFormErrorMsg">'+ msg +'</span>');
    },

    showLocationServicesPopup: function (locationID) {
        $.post(
            '/CMS/monitoring/getAllServiceDataOfLocation',
            {
                locationID: locationID
            },
            function(resp)
            {
                popup(resp.html, 'All services in '+ locationID).setSettings({"size":"large"}).dialog();
            },
            'json'
        );
    },

    updateConfigValuesOfService: function (serviceID, event) {
        // clearing error messages
        $('.messageOfUpdateConfigValues').html('');

        // the clicked button
        var button = $('#updateConfigValuesOf'+ serviceID +'Btn');

        // getting the clicked command
        var onclickCommand = button.attr('onclick');

        // removing the clicked command for the time of the process to prevent multiple execution
        button.attr('onclick', '');

        // showing spinner icon on button
        $('#updateConfigValuesOf'+ serviceID +'Btn .fa-spinner').show();


        var tableID = 'serviceConfigValuesOf'+ serviceID;

        var inputElements = $('#'+ tableID +' :input');

        if(serviceTemplates.validateServiceJSONCompilerForm(inputElements))
        {
            var formData = {};

            inputElements.each(function () {
                var item = {};
                for(var i in $(this).data()){
                    item[i] = $(this).data(i);
                }
                item['value'] = $(this).val();
                item['name'] = $(this).attr('name');
                formData[item['name']] = item;
            });

            var postData = { formData: formData };

            var unifyToThisServiceTemplate = $('#unifyTemplateVersionsOf'+ serviceID +'Select').val();
            if(unifyToThisServiceTemplate)
                postData['unifyToThisServiceTemplate'] = unifyToThisServiceTemplate;

            // updating service config values
            $.post(
                '/admin/devices/updateIndividualServiceConfigJSONValues',
                postData,
                function(r)
                {
                    // closeLastPopup();
                    $('#updateConfigValuesOf'+ serviceID +'Btn .fa-spinner').hide();
                    $('#messageOfUpdateConfigValuesOf'+ serviceID).html(r.message);
                    button.attr('onclick', onclickCommand);
                    $('#unifyTemplateVersionsOf'+ serviceID +'Select').val("0");
                }
            );
        }
        // form is invalid
        else
        {
            // restoring button's onclick command
            button.attr('onclick', onclickCommand);

            // writing message next to buttons
            $('#messageOfUpdateConfigValuesOf'+ serviceID).html('<div class="serviceJSONCompilerFormErrorMsg"><i class="fa fa-exclamation-triangle"></i> Some fields are missing the correct values</div>');

            // hiding spinner icon from button
            $('#updateConfigValuesOf'+ serviceID +'Btn .fa-spinner').hide();
        }
    },

    getConfigTableOfServiceAfterTemplateVersionUnifying: function (locationID, serviceID) {
        var newServiceTemplateID = $('#unifyTemplateVersionsOf'+ serviceID +'Select').val();

        $.post(
            '/CMS/monitoring/getAllServiceDataOfLocation',
            {
                serviceTemplateIDToBeOnAllDPs: newServiceTemplateID,
                serviceIDForTemplateVersionUnifying: serviceID,
                locationID: locationID
            },
            function(r)
            {
                $('#serviceConfigTableContainerOf'+ serviceID).html(r.html);
            }
        );
    }
};